import {
  CustomerStatusOptionsTranslation,
  customerStatusOptionsTranslation,
  CustomerTypeOptionsTranslation,
  customerTypeOptionsTranslation,
  FlagOptionsTranslation,
  flagOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';

export type ProcessesCreateTranslation = {
  button: {
    cancel: string;
    save: string;
  };
  form: {
    button: {
      assignContactOwnerAsOwner: string;
    };
    customer: {
      ai: {
        button: {
          cancel: string;
          confirm: string;
          extractFromNote: string;
          readProcessDescription: string;
          readProcessEmails: string;
          readThread: string;
        };
        createInfo: string;
        inquiryInfo: string;
        inquiryReadingProcessEmails: string;
        noMatchesAfterAi: string;
        noteLabel: string;
        notePlaceholder: string;
        noteWillBeSaved: string;
        processDescriptionInfo: string;
        processEmailsInfo: string;
        saveNote: string;
        source: {
          note: string;
          processDescription: string;
          processEmails: string;
          thread: string;
        };
        subtitleCreate: string;
        subtitleProcess: string;
        subtitleWizard: string;
        threadInfo: string;
        title: string;
        wizardInfo: string;
      };
      button: {
        chooseContact: string;
        chooseCustomer: string;
        fromAi: string;
      };
      contactOwnerId: string;
      contactSectionTitle: string;
      customerName: string;
      customerSectionTitle: string;
      firstName: string;
      flag: string;
      flagOptions: FlagOptionsTranslation;
      lastName: string;
      name: string;
      status: string;
      statusOptions: CustomerStatusOptionsTranslation;
      type: string;
      typeOptions: CustomerTypeOptionsTranslation;
    };
    description: string;
    eventTypeId: string;
    name: string;
    noteText: string;
    processCreatorId: string;
    processOwnerId: string;
  };
  noteWizard: {
    button: {
      cancel: string;
      next: string;
    };
    menuItem: string;
    menuItemHint: string;
    noteLabel: string;
    notePlaceholder: string;
    subtitle: string;
    title: string;
  };
  title: string;
};

export const processesCreateTranslation: ProcessesCreateTranslation = {
  button: {
    cancel: 'Anuluj',
    save: 'Zapisz',
  },
  form: {
    button: {
      assignContactOwnerAsOwner: 'Przypisz opiekuna jako właściciela',
    },
    customer: {
      ai: {
        button: {
          cancel: 'Anuluj',
          confirm: 'Zatwierdź',
          extractFromNote: 'Wyciągnij dane z notatki',
          readProcessDescription: 'Przeczytaj opis procesu',
          readProcessEmails: 'Przeczytaj maile procesu',
          readThread: 'Przeczytaj wątek maila',
        },
        createInfo:
          'Proces nie ma jeszcze wątku maila — wklej notatkę (np. z rozmowy telefonicznej), a AI wyciągnie z niej dane klienta i kontaktu. Pustą nazwę i opis procesu uzupełni tą samą podpowiedzią.',
        inquiryInfo:
          'Wklej notatkę (np. z rozmowy telefonicznej) — AI wyciągnie z niej klienta i kontakt, a puste parametry zapytania (termin, liczba gości, lokalizacja, nazwa) uzupełni tą samą podpowiedzią.',
        inquiryReadingProcessEmails:
          'Czytam maile procesu — uzupełnię termin, liczbę gości i lokalizację…',
        noMatchesAfterAi:
          'Kontaktu z tym adresem nie ma w bazie — poniżej dane odczytane przez AI.',
        noteLabel: 'Notatka',
        notePlaceholder:
          'Kto się odezwał, z jakiej firmy, e-mail i telefon, jakie wydarzenie, termin, liczba gości, miejsce…',
        noteWillBeSaved: 'Notatka z okna AI zapisze się w nowym procesie.',
        processDescriptionInfo:
          'AI przeczyta opis tego procesu i przygotuje z niego dane klienta i kontaktu.',
        processEmailsInfo:
          'AI przeczyta maile podpięte do tego procesu i przygotuje z nich dane klienta i kontaktu.',
        saveNote: 'Zapisz tę notatkę w procesie',
        source: {
          note: 'Z notatki',
          processDescription: 'Z opisu procesu',
          processEmails: 'Z maili procesu',
          thread: 'Z tego maila',
        },
        subtitleCreate:
          'Te same opcje co w kreatorze z maila. Zatwierdzenie zakłada w CRM nowego klienta lub kontakt, jeśli je wybrałeś.',
        subtitleProcess:
          'Te same opcje co w kreatorze z maila. Zatwierdzenie zakłada, co trzeba, i ustawia wynik na procesie.',
        subtitleWizard:
          'Te same opcje co w kreatorze. Zatwierdzenie przenosi wybór do kreatora — klienta i kontakt założy dopiero „Utwórz”.',
        threadInfo:
          'AI jeszcze raz przeczyta ten wątek maila i przygotuje z niego dane klienta i kontaktu.',
        title: 'Utwórz kontakt i klienta',
        wizardInfo:
          'Wklej notatkę (np. z rozmowy telefonicznej), żeby AI uzupełniło to, czego nie ma w mailu.',
      },
      button: {
        chooseContact: 'Przypisz kontakt wraz z jego klientem',
        chooseCustomer: 'Przypisz tylko klienta',
        fromAi: 'Utwórz kontakt i klienta',
      },
      contactOwnerId: 'Opiekun',
      contactSectionTitle: 'Kontakt',
      customerName: 'Nazwa klienta',
      customerSectionTitle: 'Klient',
      firstName: 'Imię',
      flag: 'Flaga',
      flagOptions: flagOptionsTranslation,
      lastName: 'Nazwisko',
      name: 'Nazwa',
      status: 'Status',
      statusOptions: customerStatusOptionsTranslation,
      type: 'Typ',
      typeOptions: customerTypeOptionsTranslation,
    },
    description: 'Opis',
    eventTypeId: 'Typ wydarzenia',
    name: 'Nazwa',
    noteText: 'Notatka',
    processCreatorId: 'Twórca procesu',
    processOwnerId: 'Właściciel procesu',
  },
  noteWizard: {
    button: {
      cancel: 'Anuluj',
      next: 'Dalej',
    },
    menuItem: 'Z notatki',
    menuItemHint: 'Kreator jak z maila — AI czyta notatkę',
    noteLabel: 'Notatka',
    notePlaceholder:
      'Kto się odezwał, z jakiej firmy, e-mail i telefon, jakie wydarzenie, termin, liczba gości, miejsce…',
    subtitle: 'Wklej lub napisz notatkę — AI wyciągnie z niej dane i poprowadzi Cię przez kreator.',
    title: 'Nowy proces z notatki',
  },
  title: 'Tworzenie nowego procesu',
};
